import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, Col, Row } from "reactstrap";
import Client from "./client";
import AddClient from "./add-client";

const propTypes = {
  toggleDisplay: PropTypes.func.isRequired,
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      full_name: PropTypes.string,
      email: PropTypes.string,
      agent_name: PropTypes.string,
      send_a_copy: PropTypes.bool
    })
  ),
  client: PropTypes.shape({
    id: PropTypes.number,
    full_name: PropTypes.string,
    email: PropTypes.string,
    agent_name: PropTypes.string,
    send_a_copy: PropTypes.bool
  }).isRequired,
  isAdding: PropTypes.bool.isRequired,
  isUpdating: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  addClient: PropTypes.func.isRequired,
  handleClientUpdate: PropTypes.func.isRequired,
  handleEditClient: PropTypes.func.isRequired,
  handleDeleteClient: PropTypes.func.isRequired,
  toggleClientEdit: PropTypes.func.isRequired,
  showEmailSent: PropTypes.bool.isRequired,
  editClientId: PropTypes.number,
  deleteClientId: PropTypes.number,
  errors: PropTypes.arrayOf(PropTypes.string)
};

const ManageClientsModal = ({
  toggleDisplay,
  errors = null,
  client,
  clients = [],
  addClient,
  handleClientUpdate,
  handleEditClient,
  handleDeleteClient,
  toggleClientEdit,
  editClientId = null,
  deleteClientId = null,
  isAdding,
  isUpdating,
  isDeleting,
  showEmailSent
}) => {
  return (
    <Modal
      isOpen
      toggle={toggleDisplay}
      fade={false}
      className="modal-lg account-app add-client-modal"
      id="new-campaign-client"
      centered
    >
      <ModalHeader toggle={toggleDisplay} className="m-0 pb-0" />
      <div className="text-center font-weight-bold h4 px-3">
        Show your client you&#39;re promoting their home!
      </div>
      <ModalBody className="px-4 pb-4 pt-0">
        <div className="text-center">
          They&#39;ll receive a report and will see their ad when they browse Facebook and the Web.
          94% of sellers respond favorably to seeing their ad online.
        </div>
        <hr />
        {errors && (
          <div className="notifications danger">
            {errors.map(error => (
              <div key={error}>{error}</div>
            ))}
          </div>
        )}
        <AddClient
          onSubmit={addClient}
          onChange={handleClientUpdate}
          client={client}
          isAdding={isAdding}
        />
        {clients.length > 0 && (
          <div>
            <hr />
            <Row>
              <Col className="font-weight-bold">
                Manage your email addresses for this ad campaign:
              </Col>
            </Row>
            {clients.map(c => (
              <Client
                key={c.id}
                toggleEdit={toggleClientEdit}
                showEdit={editClientId === c.id}
                updateCallback={handleEditClient}
                deleteCallback={event => handleDeleteClient(event, c.id)}
                isProcessing={isUpdating || isDeleting}
                isUpdating={isUpdating && editClientId === c.id}
                isDeleting={isDeleting && deleteClientId === c.id}
                client={c}
              />
            ))}
          </div>
        )}
        {showEmailSent && <span className="text-success font-weight-bold">First email sent!</span>}
      </ModalBody>
    </Modal>
  );
};

ManageClientsModal.propTypes = propTypes;

export default ManageClientsModal;
